import { getDateData } from "../../helpers/dateHelper";
import { stringToAlphabetSum } from "../../helpers/userImageColor";
import { getBarcodeLabels } from "../BarcodeEditorPreview/helper";
import { getData_Object } from "../BarcodeEditorSideBar/helper";

export const getCarouselLabels = ({ barcodes = [], objectType, data }) => {
  const templates = barcodes?.map((b) => {
    const objectData = data ?? getData_Object(b?.object);
    const labels = getBarcodeLabels({
      data: objectData,
      barcodeFormat: b?.format,
      fields: b.barcode,
      delimiter: b.delimiter,
      serialize: b.serialize,
      topTemplates: b.top,
      bottomTemplates: b.bottom,
      qty: 1,
      useBmp: false,
    });

    const user = {
      hueShift: stringToAlphabetSum(
        `${b.history[0].user.email}${b.history[0].user.name}`,
      ),
      name: b.history[0].user.name,
      email: b.history[0].user.email,
    };

    const time = getDateData({
      startDate: b.history[0].createdAt,
      includeYear: true,
    });

    const props = {
      id: b.id,
      objectType: b?.object,
      name: b.name,
      user,
      time,
      ...labels[0],
      size: b.size,
      barcodeProps: { format: b.format, displayValue: b.label },
    };
    return props;
  });

  if (objectType) return templates.filter((t) => t.objectType === objectType);
  else return templates;
};
